import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface AlertItem {
  id: string
  type: string
  severity: 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL'
  message: string
  vehicleId: string | null
  status: 'OPEN' | 'ACKNOWLEDGED' | 'RESOLVED'
  createdAt: string
}

interface AlertsState {
  items: AlertItem[]
  openCount: number
}

const initialState: AlertsState = {
  items: [],
  openCount: 0,
}

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    addAlert: (state, action: PayloadAction<AlertItem>) => {
      state.items.unshift(action.payload)
      if (action.payload.status === 'OPEN') state.openCount++
    },
    setAlerts: (state, action: PayloadAction<AlertItem[]>) => {
      state.items = action.payload
      state.openCount = action.payload.filter(a => a.status === 'OPEN').length
    },
    acknowledgeAlert: (state, action: PayloadAction<string>) => {
      const alert = state.items.find(a => a.id === action.payload)
      if (alert) { alert.status = 'ACKNOWLEDGED'; state.openCount = Math.max(0, state.openCount - 1) }
    },
  },
})

export const { addAlert, setAlerts, acknowledgeAlert } = alertsSlice.actions
export default alertsSlice.reducer
